<template>
  <article class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.methods.title }}</h2>
    </div>

    <section class="layout-grid">
      <div v-if="wp.methods.donationEmail" class="layout-grid__item card">
        <h3 class="card__title">Virement Interac</h3>
        <p>
          Vous pouvez faire un virement Interac via notre courriel :
          {{ wp.methods.donationEmail }}
          .
        </p>
      </div>

      <div v-if="wp.methods.donationLink" class="layout-grid__item card">
        <h3 class="card__title">Carte de crédit ou transfert bancaire</h3>
        <div class="rte">
          <p>
            Vous pouvez remplir
            <a :href="wp.methods.donationLink" target="_blank" rel="noopener noreferrer">ce formulaire</a>
            pour faire votre don.
          </p>
        </div>
      </div>

      <div v-if="wp.methods.paypalContent" class="layout-grid__item card">
        <h3 class="card__title">Paypal</h3>
        <div class="rte" v-html="wp.methods.paypalContent" />
      </div>

      <div v-if="wp.methods.checkContent" class="layout-grid__item card">
        <h3 class="card__title">Chèque</h3>
        <div class="rte" v-html="wp.methods.checkContent" />
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'DonationHow',
  inject: ['wp']
}
</script>
